import { Flex, FlexProps, IconButton } from '@chakra-ui/react'
import styled from '@emotion/styled'
import * as React from 'react'
import {
  color,
  ColorProps,
  flex,
  justifyContent,
  JustifyContentProps,
  layout,
  LayoutProps,
  maxWidth,
  minWidth,
  position,
  space,
  SpaceProps,
  width
} from 'styled-system'

export const StyledTable = styled.div<SpaceProps>`
  ${space};
  flex: 1;
  width: 100%;
  display: flex;
  max-width: 100%;
  overflow-x: auto;
  border-radius: 4px;
  flex-direction: column;
  box-sizing: border-box;
  justify-content: center;
`

export const TableHead = styled.div<SpaceProps & LayoutProps>`
  ${space};
  ${layout};
  display: flex;
  flex-direction: row;
`

export const TableCell = styled('div')<SpaceProps & ColorProps & JustifyContentProps & FlexProps>`
  ${space};
  ${color};
  ${justifyContent};
  flex: 1;
  display: flex;
  min-width: 150px;
  align-items: center;
  border-bottom-width: 1px;
  ${flex};
  ${maxWidth};
  ${minWidth};
  ${width};
  ${position};
`

export const TableRow = styled(Flex)`
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  &:hover {
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.01);
  }
`

type TableIconButtonProps = SpaceProps & {
  icon: any
  onClick: ((event: React.MouseEvent<HTMLElement, MouseEvent>) => void) | undefined
  isDisabled: boolean
  variantColor?: string
}

export const TableIconButton: React.FC<TableIconButtonProps> = ({
  icon,
  onClick,
  isDisabled,
  children,
  variantColor
}) => {
  return (
    <IconButton
      size="sm"
      icon={icon}
      borderWidth={1}
      onClick={onClick}
      variantColor={variantColor}
      isDisabled={isDisabled}
      aria-label="Table Icon button"
    >
      {children}
    </IconButton>
  )
}

TableIconButton.defaultProps = {
  variantColor: 'gray'
}
